import { ApolloError, useMutation } from '@apollo/client'
import { PromoteDemoteContentViewMutation } from 'api/graphQL/mutations/projectProductFamily.mutations'
import { handleFetchError } from 'components/WorkspaceEditor/api/utils'
import { PromoteDemoteVariables } from '../../types'

export interface ContentItemViewInput {
    projectId: string
    templateItemPartType: string
    isTrackChangeToggleOn: boolean
    rootArticleContentItemId: string[]
    nodeId: string
    features: string[]
}

export const usePromoteDemoteContentViewMutation = () => {
    const [promoteDemoteContentView] = useMutation(
        PromoteDemoteContentViewMutation(6),
        {
            fetchPolicy: 'no-cache',
            onError: (error: ApolloError) =>
                handleFetchError(
                    error,
                    'WorkspaceEditor-promoteDemoteContentView'
                ),
        }
    )

    const execute = (
        variables: PromoteDemoteVariables,
        contentItemViewInput: ContentItemViewInput
    ) =>
        promoteDemoteContentView({
            variables: {
                ...variables,
                contentItemViewInput,
            },
        })

    return { promoteDemoteContentView: execute }
}
